import React from 'react';
import NavBar from "./NavBar";
import Covid from "./Covid";

function Header() {
    return (
<div>
<NavBar/>
{/* <Covid/> */}
</div>

    )
}

export default Header